import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/webapp/hybrid apps.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const HybridApps = () => {
  const heroData = {
    title: "Cross-Platform Hybrid App Development",
    description: "Build powerful mobile apps that work seamlessly on both iOS and Android with a single codebase. We create cost-effective hybrid solutions that deliver native performance and experiences.",
    image: img13,
    imageAlt: "Hybrid Apps",
    features: [
      "React Native & Flutter",
      "Cross-platform codebase",
      "Native performance",
      "Cost-effective development",
      "Faster time-to-market",
      "Unified maintenance",
    ],
    pillars: [
      "Native performance that rivals platform-specific apps",
      "Platform-aware design that respects iOS and Android conventions",
      "Efficient development that maximizes code reuse and reduces costs",
    ],
  };

  const journeySteps = [
    {
      title: "Platform Strategy",
      description: "We define your cross-platform approach, target devices, and technology stack to maximize code reuse while maintaining native performance.",
      details: ["Platform analysis", "Device targeting", "Framework selection", "Architecture design", "Feature roadmap", "Cost optimization"],
    },
    {
      title: "Cross-Platform Design",
      description: "Our designers create adaptive interfaces that provide native experiences on both iOS and Android while sharing core UI components.",
      details: ["Adaptive UI design", "Platform guidelines", "Shared components", "Native variations", "Interactive prototypes", "Responsive layouts"],
    },
    {
      title: "Hybrid Development",
      description: "We build apps using React Native or Flutter, delivering near-native performance with a single codebase across platforms.",
      details: ["React Native/Flutter", "Shared business logic", "Native modules", "API integration", "Performance optimization", "Code reusability"],
    },
    {
      title: "Testing & Deployment",
      description: "Comprehensive testing on both platforms ensures consistent functionality and performance across iOS and Android devices.",
      details: ["Cross-platform testing", "Device compatibility", "Performance validation", "Store submissions", "Launch coordination", "Continuous updates"],
    },
  ];

  const capabilities = [
    {
      title: "React Native Development",
      content:
        "Build high-performance hybrid apps with React Native, leveraging JavaScript expertise for iOS and Android development.",
    },
    {
      title: "Flutter Development",
      content:
        "Create beautiful, natively compiled apps with Flutter's powerful framework and expressive UI toolkit.",
    },
    {
      title: "Code Sharing",
      content:
        "Maximize efficiency with shared business logic and UI components across platforms, reducing development time and costs.",
    },
    {
      title: "Native Modules",
      content:
        "Integrate native platform features through custom modules when needed for optimal performance and functionality.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "50%", label: "Development cost reduction" },
      { value: "60%", label: "Faster time-to-market" },
      { value: "95%", label: "Code reuse across platforms" },
    ],
    description: "We deliver hybrid apps that achieve significant cost savings, faster launches, and performance comparable to native apps across both platforms.",
  };

  const outcomesData = {
    description: "We create hybrid apps that deliver native-quality experiences on both iOS and Android, maximizing your reach while optimizing development efficiency and costs.",
    outcomes: [
      "React Native or Flutter cross-platform development",
      "Single codebase for iOS and Android",
      "Native performance and user experience",
      "Platform-specific customizations when needed",
      "Hot reload for rapid development",
      "Shared business logic and components",
    ],
  };

  const whyChooseUs = [
    {
      title: "Cost Efficient",
      content:
        "Single codebase development significantly reduces costs compared to building separate native apps for each platform.",
    },
    {
      title: "Faster Time-to-Market",
      content:
        "Launch on both iOS and Android simultaneously, reaching your entire audience faster with unified development.",
    },
    {
      title: "Native Performance",
      content:
        "Modern hybrid frameworks deliver near-native performance with smooth animations and responsive interfaces.",
    },
    {
      title: "Easy Maintenance",
      content:
        "Updates and bug fixes are deployed across all platforms simultaneously, simplifying maintenance and reducing costs.",
    },
  ];

  const faqs = [
    {
      q: "What's the difference between React Native and Flutter?",
      a: "React Native uses JavaScript and is ideal if you have web development experience, while Flutter uses Dart and offers more consistent UI across platforms. We recommend the best framework based on your project needs and team expertise.",
    },
    {
      q: "How much can I save with hybrid app development?",
      a: "Hybrid development typically reduces costs by 40-60% compared to building separate native apps. You also save on ongoing maintenance by updating a single codebase instead of two.",
    },
    {
      q: "Will my hybrid app perform as well as a native app?",
      a: "Yes! Modern frameworks like React Native and Flutter deliver near-native performance for most applications. For highly specialized features, we can integrate native modules to maintain optimal performance.",
    },
    {
      q: "Can you convert my existing native app to hybrid?",
      a: "Absolutely. We can migrate your native iOS or Android app to a hybrid framework, preserving functionality while enabling cross-platform compatibility and reducing future development costs.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Hybrid App Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Hybrid App Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default HybridApps;
